var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nuxt-link',{staticClass:"teaser-image",attrs:{"to":_vm.imageLink,"title":_vm.node.title}},[_c('nuxt-img',{attrs:{"src":_vm.imageSrc,"width":"150","height":"150","alt":_vm.mediaMeta.alt,"title":_vm.mediaMeta.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }